import {
  CountryCode,
  OrganizationCode,
  OrganizationCodeDescription,
} from '@quromedical/fhir-common';
import type {
  OrganizationContactUpdateRequest,
  OrganizationGeneral,
  OrganizationGeneralBase,
  OrganizationSearch,
  PersonContact,
} from '@quromedical/models';
import type { Field, SelectOption } from 'components/types';
import type { Fetcher } from 'design-system';
import { strings } from 'strings';

export const getDescription = (code?: OrganizationCode): string | undefined => {
  if (!code) {
    return undefined;
  }

  return OrganizationCodeDescription[code];
};

export const initialData: Partial<OrganizationContactUpdateRequest> = {
  contact: {
    addressCountry: CountryCode.SouthAfrica,
    addressCity: '',
    addressLines: [],
    addressPostalCode: '',
    telecomEmail: '',
    telecomPhoneNumbers: [],
  },
};
const typeCodes = Object.values(OrganizationCode);
const typeOptions = typeCodes.map<SelectOption>((code) => ({
  display: getDescription(code) || code,
  value: code,
}));

export type OrganizationWithOutCoordinates = OrganizationGeneral &
  Omit<PersonContact, 'addressCoordinates'>;

export const initialSearch: Partial<OrganizationSearch> = {
  name: '',
  address: '',
};

export const searchFields: Field<OrganizationSearch>[] = [
  {
    subfields: [
      {
        type: 'text-box',
        key: 'name',
        label: strings.LabelName,
        placeholder: 'Enter Name',
      },
      {
        type: 'text-box',
        key: 'address',
        label: strings.LabelAddress,
        placeholder: 'Enter Address',
      },
      {
        type: 'combobox-single',
        key: 'type',
        label: strings.LabelOrganizationType,
        fetcher: [
          {
            display: 'All',
            value: undefined,
          },
          ...typeOptions,
        ],
      },
    ],
  },
];

export const createOrganizationGeneralRows = (
  schemeFetcher: Fetcher<string, unknown>,
  type?: OrganizationCode,
): Field<OrganizationGeneralBase>[] => {
  const baseFields: Field<OrganizationGeneral> = {
    subfields: [
      {
        type: 'text-box',
        key: 'name',
        label: strings.LabelName,
        placeholder: 'Enter Name',
      },
      {
        type: 'combobox-single',
        key: 'type',
        label: strings.LabelOrganizationType,
        fetcher: typeOptions,
      },
    ],
  };

  if (type !== OrganizationCode.InsuranceCompany) {
    return [baseFields];
  }

  return [
    baseFields,
    {
      subfields: [
        {
          type: 'combobox-single',
          key: 'schemeCode',
          searchable: true,
          label: strings.FormLabelScheme,
          fetcher: schemeFetcher,
        },
      ],
    },
  ];
};
